import { OrderDetailRoutingService } from '../services/order-detail-routing.service';
export const routerNamings = [
    {
        url: 'v2/order/create',
        name: 'generic_new_order'
    },
    {
        url: '/order/create/*',
        name: 'generic_new_order'
    },
    {
        url: '/dashboard',
        name: 'generic_home'
    },
    {
        url: '/profile',
        name: 'generic_profile'
    }
];

export const noBackwardNavigation = [
    {
        url: '/dashboard',
    }
];

export const backwardNavigation = [
    {
        url: 'v2/order/create',
        hasModal: true,
        backUrl: '/dashboard'
    },
    {
        url: '/order/create/*',
        hasModal: true,
        backUrl: '/dashboard'
    },
    {
        url: '/order/detail/*',
        hasModal: false,
        backUrl: '/order/list'
    },
    {
        url: '/profile',
        hasModal: false,
        backUrl: '/dashboard'
    },
];


export function getRouteNaming(url: string) {

    for (const route of routerNamings) {
        if (urlCheck(url, route)) { return route; }
    }

    return null;

}

export function shouldNavigateBack(url: string): boolean {

    if (url === '/') { return false; }

    for (const route of noBackwardNavigation) {
        if (urlCheck(url, route)) { return false; }
    }

    return true;

}

export function getNavigateBackUrl(url: string, orderDetailRoutingService: OrderDetailRoutingService) {

    if (urlCheck(url, { url: '/order/detail/*' })) {
        if (orderDetailRoutingService.getOrigin() === 'list') {
            return {
                url: '/order/detail/*',
                hasModal: false,
                backUrl: '/order/list'
            };
        } else {
            return {
                url: '/order/detail/*',
                hasModal: false,
                backUrl: '/dashboard'
            };
        }
    }

    for (const route of backwardNavigation) {
        if (urlCheck(url, route)) { return route; }
    }

    return null;


}

function urlCheck(url, route): boolean {

    let match = true;

    if (route.url.indexOf('*') >= 0) {

        const checkUrl: string[] = route.url.split('*');
        const index = checkUrl.indexOf('*');
        checkUrl.splice(index, 1);

        checkUrl.forEach((urlPart) => {
            if (url.indexOf(urlPart) < 0) {
                match = false;
            }
        });

    } else {
        match = (url.indexOf(route.url) >= 0);
    }

    return match;

}
